var map = {
	"./checkMark.svg": 59573,
	"./cross_red.svg": 3814,
	"./receipt-lightblue.svg": 92293,
	"./receipt-red.svg": 14728,
	"./receipt29.svg": 58597,
	"./receipt30.svg": 91823,
	"./receipt31.svg": 71774,
	"./receipt32.svg": 18045,
	"./receipt33.svg": 89500,
	"./receipt34.svg": 87427,
	"./receipt35.svg": 84114,
	"./receipt36.svg": 89153,
	"./receipt37.svg": 98032,
	"./receipt38.svg": 78599,
	"./receipt39.svg": 31734,
	"./receipt8.svg": 71646,
	"./upload.svg": 11785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67552;